<template>
	<div>
		<template v-if="!islist">
			<div style="position: absolute;top: 26px;right: 4px;">
				<van-tag type="success" v-if="value">已审核</van-tag>
				<van-tag type="danger" v-else>未审核</van-tag>
			</div>
		</template>
		<template v-else>
			<van-field label="审核状态" :value="valuetext" placeholder="" @click="show"
				input-align="right">
				<template #left-icon>
					<van-icon v-if="!disabled && !readonly" name="edit" color="#07c160" />
				</template>
			</van-field>
			<van-popup v-model="showPicker" round position="bottom" :safe-area-inset-bottom="true" get-container="body">
				<van-picker title="审核状态" value-key="label" show-toolbar :columns="['未审核','已审核']"
					@cancel="showPicker = false" @confirm="onConfirm" />
			</van-popup>
			
<!-- 			<el-select size="mini" :value="value" clearable transfer filterable placeholder="请选择" @change="change" :collapse-tags="true">
				<el-option label="未审核" value="0"></el-option>
				<el-option label="已审核" value="1"></el-option>
			</el-select> -->
		</template>
		

	</div>
</template>

<script>
	import inputBase from '@_system/components/base/input.js'
	import selectBase from '@_system/components/base/select.js'
	export default {
		mixins: [inputBase, selectBase],
		props: {
			table: {
				type: Object,
				default: () => {
					return null
				}
			},
			row: {
				type: Object,
				default: () => {
					return null
				}
			},
			column: {
				type: Object,
				default: () => {
					return null
				}
			},
			moduleName: {
				type: String,
				default: () => {
					return ''
				}
			},
		},
		data() {
			return {
				valuetext:'',
				showPicker:false
			}
		},
		created() {

		},
		mounted() {

		},
		watch: {

		},
		computed: {

		},
		methods: {
			show(){
				this.showPicker = true
			},
			auditorinfo() {
				

			},
			onConfirm(value, index) {
				if(index==0){
					this.valuetext = '未审核'
				}
				if(index==1){
					this.valuetext = '已审核'
				}
				this.change(index)
				this.showPicker = false
			},
		},
		components: {

		}
	}
</script>
